// extracted by mini-css-extract-plugin
export default {"titleSectionContainer":"TitleSection_titleSectionContainer__GNVFl","titleContainer":"TitleSection_titleContainer__8spnH","scoreTable":"TitleSection_scoreTable__el1if"};